import axios from "axios";
const host = "https://appserver.easesdk.com";
export const getToken = (userId: string, nickname: string, avatar: string) => {
  return axios.post(`${host}/inside/app/user/special/login`);
};

export const createChatroom = (chatroomName: string, ownerId: string) => {
  const token = sessionStorage.getItem("chatroom-token");
  return axios.post(
    `${host}/inside/app/user/room`,
    {
      roomName: chatroomName,
      owner: ownerId,
    },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
};

export const getChatroomList = () => {
  const token = sessionStorage.getItem("chatroom-token");
  return axios.get(`${host}/internal/appserver/liverooms`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const deleteChatroom = (roomId: string) => {
  const token = sessionStorage.getItem("chatroom-token");
  return axios.delete(`${host}/liverooms/${roomId}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};
